import {Injectable} from '@angular/core';
import {AuthApiHttpClient} from '../common/auth/auth-api-http-client';
import {DataItemService} from '../common/data/data-item.service';
import {ActivatedRoute} from '@angular/router';
import { Charger } from '../models/charger';

@Injectable({providedIn: 'root'})
export class ChargerItemService extends DataItemService<Charger> {
  public hospitalList: any;
  constructor(httpClient: AuthApiHttpClient, route: ActivatedRoute) {
    super({
      httpClient,
      url: 'health/chargers/item'
    });

    this.hospitalList = this.httpClient.get<Array<string>>('health/cradles/customerCodes');
  }
}
